import { createFileRoute, Navigate } from "@tanstack/react-router";
import { useGetMyFeatures } from "@tubo/api-models/hooks/tenant-feature-api.hooks";
import type { FileRouteTypes } from "@client/routeTree.gen";
import { useUiTranslation } from "@tubo/ui/i18n";

export const Route = createFileRoute("/_app/semantic-platform/")({
  component: SemanticPlatformIndex,
});

type FeatureKey = "dataModel" | "semanticAsset" | "run" | "assetPublishing" | "structuredKnowledge";

/** 落地页:按旅程顺序重定向到当前租户第一个可用的二级页(知识本体 route 兜底拦截全关租户) */
const LANDING_CANDIDATES: Array<{ to: FileRouteTypes["to"]; feature: FeatureKey }> = [
  { to: "/semantic-platform/concepts", feature: "semanticAsset" },
  { to: "/semantic-platform/data-models", feature: "dataModel" },
  { to: "/semantic-platform/data-assets", feature: "assetPublishing" },
  { to: "/semantic-platform/knowledge-debug", feature: "structuredKnowledge" },
];

function SemanticPlatformIndex() {
  const { t } = useUiTranslation("semanticPlatform");
  const { data: features, isLoading } = useGetMyFeatures({ query: {} });

  if (isLoading) {
    return <div className="flex h-full items-center justify-center text-muted-foreground">{t("common.loading")}</div>;
  }

  const target =
    LANDING_CANDIDATES.find((c) => features?.[c.feature] === true)?.to ??
    "/semantic-platform/data-models";

  return <Navigate to={target} replace />;
}
